import { z } from 'zod';

import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const EliteLoanExtensionAgreementInput = z.object({
  lenderLLC: z.string(),
  extensionFeeAmount: z.number().optional(),
  deferExtensionFee: z.boolean().optional(),
  legalFeeAmount: z.number().optional(),
  administrationFeeAmount: z.number().optional(),
  bpoFeeAmount: z.number().optional(),
  revisionFeeAmount: z.number().optional(),
  newMaturityDate: zodDateOrString.optional(),
  newInterestRate: z.number().optional(),
  guarantorNames: z.array(z.string()).optional(),
});
export type EliteLoanExtensionAgreementInput = z.infer<typeof EliteLoanExtensionAgreementInput>;

export const CreateLoanExtensionAgreementEvent = BaseLoanEvent.extend({
  type: z.literal('createLoanExtensionAgreement'),
  input: EliteLoanExtensionAgreementInput, // If more lenders are added, make this a union
});
export type CreateLoanExtensionAgreementEvent = z.infer<typeof CreateLoanExtensionAgreementEvent>;
